import { getAllMembers } from "app/services/distributorService";

import React, { Component } from "react";
import AsyncSelect from "react-select/async";

class AllMemberAutoComplete extends Component {
  constructor() {
    super();
    this.state = {
      selectedValue: null,
      inputValue: "",
    };
  }
  // handle input change event
  handleInputChange = (value) => {
    this.setState({ inputValue: value });
  };

  handleChange = (value) => {
    this.props.setAffiliateResponse(value);
    this.setState({ selectedValue: value });
    this.props.setFieldValue("memberId", value.id);
    this.props.setFieldValue("balance", value.balance);

    this.props.handleChangeOptions(value.id);
  };
  refreshFilter = () => {
    this.props.refreshFilter();
  };
  // load options using API call
  loadOptions = async (value) => {
    const inputValue = value.trim().toLowerCase();
    const { data } = await getAllMembers(inputValue);
    const memberData = [];
    if (data?.data?.length > 0) {
      data.data.map((item) =>
        memberData.push({
          id: item.memId,
          label: `${item.uniqueIdentity} - ${item.company} - ${item.memberMobileNo} - ${item.memberType} `,
          balance: `${item.balance}`,
        })
      );
    }

    return memberData;
  };

  render() {
    return (
      <AsyncSelect
        cacheOptions
        defaultOptions
        value={this.state.selectedValue}
        getOptionLabel={(e) => e.label}
        getOptionValue={(e) => e.id}
        loadOptions={this.loadOptions}
        onInputChange={this.handleInputChange}
        onChange={this.handleChange}
        name="memberId"
      />
    );
  }
}
export default AllMemberAutoComplete;
